import axios from '../../axios'
export default {
  namespaced: true,
  state: {
    drivers: []
  },
  mutations: {
    ADD_ITEM(state, item) {
      state.products.unshift(item)
    },
    SET_DRIVERS(state, drivers) {
      state.drivers = drivers
    },
    UPDATE_DRIVER(state, driver) {
      const productIndex = state.drivers.findIndex((p) => p.id === driver.id)
      Object.assign(state.drivers, product)
    },
    REMOVE_DRIVER(state, itemId) {
      const ItemIndex = state.drivers.findIndex((p) => p.id === itemId)
      state.drivers.splice(ItemIndex, 1)
    }
  },
  actions: {
    addItem({ commit }, item) {
      return new Promise((resolve, reject) => {
        axios.post('eld/drivers/', (item)
        )
          .then((response) => {
            resolve(response)
          })
          .catch((error) => { reject(error) })
      })
    },
    fetchDataListItems({ commit }) {
      return new Promise((resolve, reject) => {
        axios.get('eld/drivers/')
          .then((response) => {
            commit('SET_DRIVERS', response.data.data)
            resolve(response)
          })
          .catch((error) => { reject(error) })
      })
    },
    updateItem({ commit }, item) {
      return new Promise((resolve, reject) => {
        axios.patch(`eld/drivers/${item.id}/`,
          (item)
        )
          .then((response) => {
            resolve(response)
          })
          .catch((error) => { reject(error) })
      })
    },
    removeItem({ commit }, itemId) {
      return new Promise((resolve, reject) => {
        axios.delete(`eld/drivers/${itemId}/`
        )
          .then((response) => {
            commit('REMOVE_DRIVER', itemId)
            resolve(response)
          })
          .catch((error) => { reject(error) })
      })
    }
  },
  getters: {}
}